import { getInitials } from '@tempo-io/string-util';
import { Avatar, AvatarFallback, AvatarImage } from '@tempo-io/sui-avatar';
import { Checkbox } from '@tempo-io/sui-checkbox';
import type { TempoUserResponse } from '@/lib/api/types/userManagement';

interface UserRowProps {
  user: TempoUserResponse;
  isChecked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export const UserRow = ({ user, isChecked, onCheckedChange }: UserRowProps) => {
  return (
    <div className="flex items-center gap-3 p-3 hover:bg-bg-neutral-subtle/50 transition-colors">
      <Checkbox checked={isChecked} onCheckedChange={onCheckedChange} />
      <Avatar size="lg">
        <AvatarImage src={user.pictureUrl} alt={user.name || user.email} />
        <AvatarFallback>{getInitials(user.name || user.email)}</AvatarFallback>
      </Avatar>
      <div className="flex flex-col min-w-0 flex-1">
        <span className="text-sm font-normal truncate">{user.name || user.email}</span>
        <span className="text-sm text-text-neutral-secondary truncate">{user.email}</span>
      </div>
    </div>
  );
};
